import { Preset } from '@primeuix/themes/types';
import { definePreset } from '@primeuix/themes';
import { PrimeNGConfigType } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { ezButtonThemeConfig } from './ez-button';
import { ezCheckboxThemeConfig } from './ez-checkbox';
import { ezInputTextThemeConfig } from './ez-input-text';
import { ezTextareaThemeConfig } from './ez-textarea';
import { ezSelectThemeConfig } from './ez-select';
import { ezMultiselectThemeConfig } from './ez-multiselect';
import { ezTabsThemeConfig } from './ez-tabs';
import { ezRadioButtonThemeConfig } from './ez-radio-button';
import { ezToggleSwitchThemeConfig } from './ez-toggle-switch';
import { ezToolbarThemeConfig } from './ez-toolbar';

export const EzPreset: Preset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{emerald.50}',
      100: '{emerald.100}',
      200: '{emerald.200}',
      300: '{emerald.300}',
      400: '{emerald.400}',
      500: '{emerald.500}',
      600: '{emerald.600}',
      700: '{emerald.700}',
      800: '{emerald.800}',
      900: '{emerald.900}',
      950: '{emerald.950}',
    },
    success: {
      50: '#FBFEFC',
      100: '#F2FAF6',
      200: '#E5F5EC',
      300: '#C0E5D1',
      400: '#97D4B4',
      500: '#6BC497',
      600: '#47B881',
      700: '#0C9D61',
      // 800: '#',
      // 900: '#',
      // 950: '#',
    },
  },
  components: {
    button: ezButtonThemeConfig,
    checkbox: ezCheckboxThemeConfig,
    inputtext: ezInputTextThemeConfig,
    textarea: ezTextareaThemeConfig,
    select: ezSelectThemeConfig,
    multiselect: ezMultiselectThemeConfig,
    tabs: ezTabsThemeConfig,
    radiobutton: ezRadioButtonThemeConfig,
    toggleswitch: ezToggleSwitchThemeConfig,
    toolbar: ezToolbarThemeConfig,
  },
});

export const primeNgConfig: PrimeNGConfigType = {
  theme: {
    preset: EzPreset,
    options: {
      ripple: true,
      darkModeSelector: 'none',
    },
  },
  translation: {
    dayNames: [
      'Domingo',
      'Segunda',
      'Terça',
      'Quarta',
      'Quinta',
      'Sexta',
      'Sábado',
    ],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    monthNames: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Mail',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    monthNamesShort: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    today: 'Hoje',
    clear: 'Limpar',
  },
};
